<template>
  <form class="flex flex-col" enctype="multipart/form-data" novalidate @submit.prevent="save()">
    <div class="modal-body">
      <div class="mb-2" v-if="files.length">
        <div class="file" v-for="(file, index) in files" :key="index">
          <span class="file-icon" v-if="!file.error">{{ file.extension }}</span>
          <span class="file-icon cursor-pointer" v-else @click="retry(file)">
            <font-awesome-icon :icon="['fas', 'sync-alt']" class="text-lg" />
          </span>
          <div class="file-info">
            <div class="flex justify-between items-center w-full inline-block">
              <span class="file-name ellipsis" :class="{ 'success': file.completed, 'error': file.error }">
                {{ file.name }}
              </span>
              <span class="file-size">{{ getSize(file.size) }}</span>
            </div>
            <div class="meter" v-if="!file.completed">
              <span class="progress" :style="{ width: file.percent + '%' }" :class="{ 'error': file.error }"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="dropzone">
        <input type="file" :multiple="false" class="input-file" name="documents" accept="image/*,.pdf" @change="filesChanged($event)">
        <span>Drag files here or browse</span>
      </div>
    </div>
    <div class="modal-footer rounded-b">
      <button type="button" class="btn btn-tertiary btn-sm" @click="hide()" :disabled="inProgress">Cancel</button>
      <button type="submit" class="btn btn-primary btn-sm" :disabled="inProgress">Opslaan</button>
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import ApiService from '@/common/api.service';

import { mapMutations } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { HIDE_MODAL } from '@/store/mutations.types';

const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

export default {
  name: 'SourceModal',
  template: '#source-modal-template',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      files: [],
      completedFiles: [],
      isCompleted: false,
      inProgress: false,
      order: null
    };
  },
  created() {
    this.order = this.$store.state.modal.items;
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL
    }),
    filesChanged(event) {
      this.files = [];
      for (let index = 0; index < event.target.files.length; index++) {
        this.files.push(
          Object.assign(event.target.files[index], {
            percent: 0,
            error: null,
            completed: false,
            extension: event.target.files[index].name.split('.').pop()
          })
        );
      }
    },
    getSize(bytes) {
      if (bytes == 0) return '0 Bytes';

      let i = Math.floor(Math.log(bytes) / Math.log(1024));
      return (
        parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i]
      );
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(() => resolve('resolve'), ms));
    },
    async save() {
      if (!this.files.length) return;

      this.inProgress = true;

      await Promise.all(
        this.files.map((file, index) => this.upload(file, index))
      ).catch(() => (this.isCompleted = false));

      this.inProgress = false;

      if (this.isCompleted) {
        this.completedFiles = [];
        await this.sleep(500);
        return this.hide();
      }
    },
    async retry(currentFile) {
      this.inProgress = true;

      await Promise.all(
        this.files.map(async (file, index) => {
          if (file.id === currentFile) {
            return await this.upload(file, index);
          }
        })
      ).catch(() => (this.isCompleted = false));

      this.inProgress = false;

      if (this.isCompleted) {
        await this.sleep(250);
        return this.hide();
      }
    },
    async upload(file, index) {
      const _this = this;

      const formData = new FormData();
      formData.set('file', file);
      formData.set('type', this.order.type);

      try {
        const config = {
          onUploadProgress: function(event) {
            file.percent = Math.round((event.loaded / event.total) * 100);
            Vue.set(_this.files, index, file);
          }
        };

        let url = `/v1/orders/${this.order.id}/store-file`;

        if (this.order.type == 'map') {
          url = `/v1/subjects/${this.order.subjectId}/map`;
        }

        const response = await ApiService.post(url, formData, config);

        file.error = false;
        file.completed = true;

        this.completedFiles.push(response.data.data);
        this.$store.commit('modal/setItems', {
          type: this.order.type,
          files: this.completedFiles
        });
        this.isCompleted = true;
      } catch (error) {
        file.error = true;
        file.completed = false;

        this.isCompleted = false;
        throw new Error('error');
      }

      Vue.set(_this.files, index, file);
    }
  }
};
</script>
